import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";
import { Lock, Mail } from "lucide-react";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/chiedi" replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Accesso effettuato");
      navigate("/chiedi");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Errore di autenticazione");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex">
      {/* left panel */}
      <div
        className="hidden lg:flex lg:flex-1 relative items-center justify-center px-12"
        style={{
          background:
            "linear-gradient(135deg, #0F3D6B 0%, #0a2948 60%, #0F3D6B 100%)",
        }}
      >
        <div className="absolute inset-0 opacity-20" style={{
          backgroundImage: "url('https://static.prod-images.emergentagent.com/jobs/336454b2-bad7-4dca-a7fc-1eebc7f8a57d/images/57a2517403e23dd12f78c1396f18c715983706f9d37d7287702bec2e54cda548.png')",
          backgroundSize: "cover", backgroundPosition: "center",
          mixBlendMode: "luminosity",
        }} />
        <div className="relative max-w-md text-white">
          <div className="adr-overline mb-6 text-white/70">
            Confindustria Medio Adriatico
          </div>
          <h1 className="serif text-5xl font-semibold tracking-tight leading-[1.05] mb-6">
            Trasforma le idee in soluzioni AI, senza scrivere codice.
          </h1>
          <p className="text-white/85 text-base leading-relaxed mb-10">
            ADRIAI Builder è la piattaforma no-code che permette alle PMI
            associate di generare documenti, applicazioni, analisi e contenuti
            in linguaggio naturale, in pochi minuti.
          </p>
          <div className="grid grid-cols-3 gap-6 pt-6 border-t border-white/15">
            <div>
              <div className="serif text-3xl font-semibold">10+</div>
              <div className="text-xs text-white/70 uppercase tracking-wider">
                Ricette pronte
              </div>
            </div>
            <div>
              <div className="serif text-3xl font-semibold">100%</div>
              <div className="text-xs text-white/70 uppercase tracking-wider">
                In italiano
              </div>
            </div>
            <div>
              <div className="serif text-3xl font-semibold">GDPR</div>
              <div className="text-xs text-white/70 uppercase tracking-wider">
                Compliant
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* right panel */}
      <div className="flex-1 flex items-center justify-center px-6 py-10 bg-white">
        <div className="w-full max-w-md">
          <div className="lg:hidden flex items-center gap-2 mb-8">
            <div className="w-9 h-9 rounded-md flex items-center justify-center text-white font-bold" style={{ background: "#0F3D6B" }}>
              A
            </div>
            <span className="serif text-xl font-semibold">ADRIAI Builder</span>
          </div>
          <div className="adr-overline mb-2">Accesso piattaforma</div>
          <h2 className="serif text-3xl font-semibold tracking-tight text-[#1A1A1A] mb-3">
            Bentornato
          </h2>
          <p className="text-[#555555] text-sm mb-8">
            Inserisci le tue credenziali per accedere ad ADRIAI Builder.
          </p>

          <form onSubmit={handleSubmit} className="space-y-4" data-testid="login-form">
            <div>
              <label className="adr-label" htmlFor="login-email">Email</label>
              <div className="relative">
                <Mail className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-[#555555]" />
                <input
                  id="login-email"
                  data-testid="login-email-input"
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="nome@azienda.it"
                  className="adr-input pl-9"
                  autoComplete="email"
                />
              </div>
            </div>
            <div>
              <label className="adr-label" htmlFor="login-pwd">Password</label>
              <div className="relative">
                <Lock className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-[#555555]" />
                <input
                  id="login-pwd"
                  data-testid="login-password-input"
                  type="password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="adr-input pl-9"
                  autoComplete="current-password"
                />
              </div>
            </div>
            <button
              type="submit"
              disabled={loading}
              data-testid="login-submit-button"
              className="adr-btn-primary w-full"
            >
              {loading ? "Accesso in corso..." : "Accedi"}
            </button>
          </form>

          <div className="mt-8 p-3 rounded-lg bg-[#F2F5F8] text-xs text-[#555555] leading-relaxed">
            <div className="font-semibold text-[#1A1A1A] mb-1">
              Demo amministratore
            </div>
            <div>Email: admin@confindustria-medioadriatico.it</div>
            <div>Password: Admin123!</div>
          </div>
        </div>
      </div>
    </div>
  );
}
